module.exports = __webpack_public_path__ + "img/lens-160-minus-01.194c8e13.png";